import { render, staticRenderFns } from "./BookstoreDetails.vue?vue&type=template&id=404d29da&scoped=true&"
import script from "./BookstoreDetails.vue?vue&type=script&lang=js&"
export * from "./BookstoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookstoreDetails.vue?vue&type=style&index=0&id=404d29da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d29da",
  null
  
)

export default component.exports